export const mileage = {
  valid: '1',
  invalid: '2',
};
